import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Tag, Card, Input, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, SearchOutlined, TeamOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { superCompanyApi } from '../../services/api';

const SuperCompanies = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });

  const fetchData = async (page = 1, pageSize = 20, kw = keyword) => {
    setLoading(true);
    try {
      const res = await superCompanyApi.list({ page, pageSize, keyword: kw || undefined });
      if (res.success) {
        setData(res.data.list);
        setPagination({ current: res.data.page, pageSize: res.data.pageSize, total: res.data.total });
      }
    } catch {
      // handled by interceptor
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  const handleDelete = async (id) => {
    try {
      const res = await superCompanyApi.delete(id);
      if (res.success) {
        message.success(res.message);
        fetchData(pagination.current, pagination.pageSize);
      }
    } catch {
      // handled by interceptor
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '公司名称', dataIndex: 'name', width: 150 },
    { title: 'URL标识', dataIndex: 'slug', width: 120, render: (slug) => <Tag>{slug}</Tag> },
    { title: '联系人', dataIndex: 'contact_name', width: 100 },
    { title: '联系电话', dataIndex: 'contact_phone', width: 120 },
    { title: '货品数', dataIndex: 'product_count', width: 80 },
    { title: '门店数', dataIndex: 'store_count', width: 80 },
    { title: '管理员数', dataIndex: 'admin_count', width: 80 },
    {
      title: '状态', dataIndex: 'is_active', width: 80, render: (v) =>
        v ? <Tag color="green">启用</Tag> : <Tag color="red">禁用</Tag>
    },
    {
      title: '操作', width: 200, render: (_, record) => (
        <Space>
          <Button type="link" icon={<TeamOutlined />} onClick={() => navigate(`/super/companies/${record.id}/admins`)}>管理员</Button>
          <Button type="link" icon={<EditOutlined />} onClick={() => navigate(`/super/companies/${record.id}/edit`)}>编辑</Button>
          {record.id !== 1 && (
            <Popconfirm title="确定要禁用该公司吗？" onConfirm={() => handleDelete(record.id)}>
              <Button type="link" danger icon={<DeleteOutlined />}>禁用</Button>
            </Popconfirm>
          )}
        </Space>
      )
    },
  ];

  return (
    <Card>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <Space>
          <Input placeholder="搜索公司名称" value={keyword} onChange={e => setKeyword(e.target.value)}
            onPressEnter={() => fetchData(1, pagination.pageSize, keyword)} style={{ width: 200 }} />
          <Button icon={<SearchOutlined />} onClick={() => fetchData(1, pagination.pageSize, keyword)}>搜索</Button>
        </Space>
        <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/super/companies/new')}>添加公司</Button>
      </div>

      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{
          ...pagination,
          onChange: (page, pageSize) => fetchData(page, pageSize),
        }}
      />
    </Card>
  );
};

export default SuperCompanies;
